import { Button } from "@/shared/components";
import { PropsWithChildren } from "react";

type SecondaryActionButtonProps = {
    onClick: () => void;
    action: "previous" | "decline";
};

export function SecondaryActionButton({ onClick, children, action }: Readonly<PropsWithChildren<SecondaryActionButtonProps>>) {
    if (action === "previous") {
        return (
            <Button type="button" variant="tertiary" onClick={onClick}>
                {children}
            </Button>
        );
    }

    return (
        <Button type="button" destructive variant="tertiary" onClick={onClick}>
            {children}
        </Button>
    );
}
